import React from "react";

export default function Progressbar() {
  return (
    <div className="progressbar">
      <div className="progressstatus"></div>
    </div>
  );
}
